import { P2GBox } from '@parcel2go/core-ui';
import { P2GText } from '@parcel2go/core-ui';
import { useMemo } from 'react';
import { GroupingPanel, ShowGroup } from '../panels/GroupingPanel';
import { SmartSendItemGroup } from './SmartSendGroup';
import { P2GGrid } from '@parcel2go/core-ui';
import { P2GLink } from '@parcel2go/core-ui';
import { HeaderPadding } from '../../../lib/consts/LayoutConstants';
import { SettingsCache } from '~/lib/consts/settings-cache';
import { useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';

interface props {
  group: SmartSendItemGroup;
  all: boolean;
  toggleAll: () => void;
  isXs: boolean;
}

export default function SmartSendGroupHeader(props: props) {
  const { t } = useTranslation(TranslationNamespaces.SMARTSEND);
  const showGroup = useMemo(() => !props.isXs && ShowGroup(props.group.Items), [props.group.Items, props.isXs]);
  const showSelectAll = !props.isXs && props.group.Items.length > 1;
  const groupingEnabled = SettingsCache.settings.Features.includes('ParcelSplitting');

  return (
    <div className="p2g-ss-group-header">
      <P2GGrid container alignItems="center" spacing={1}>
        {showSelectAll && (
          <P2GGrid flexShrink={1} item>
            <P2GLink onClick={props.toggleAll}>{props.all ? 'Deselect' : `Select`}</P2GLink>:
          </P2GGrid>
        )}
        <P2GGrid flexShrink={1} item>
          <P2GBox pl={HeaderPadding}>
            <P2GText>
              <strong>
                {props.group.Title} ({props.group.Items.length})
              </strong>
            </P2GText>
          </P2GBox>
        </P2GGrid>
        <P2GGrid flexGrow={1} item />
        {showGroup && groupingEnabled && (
          <P2GGrid flexShrink={1} item>
            <GroupingPanel
              group={props.group}
              source="ITEM-GROUP"
              control={
                <P2GLink variant="primary">
                  {t('VIEW_SHIPMENT_OPTIONS_BUTTON', { defaultValue: 'View Shipment Options' })}
                </P2GLink>
              }
            />
          </P2GGrid>
        )}
      </P2GGrid>
    </div>
  );
}
